<div class="app-component container-fluid">
    <mob-header></mob-header>
    <router-outlet ></router-outlet>
    <mob-loading></mob-loading>
    <mob-faq [pageview]="activatedRoute" [faqItems]="currentFaqItems" *ngIf="currentFaqItems.length > 0 && !pageService.isPageLoading && pageService.showFaq">
    </mob-faq>
    <mob-error-viewer *ngIf="showErrorViewer"></mob-error-viewer>
</div>
